<template>
  <div>
    <div class="m-b-10 f-s-10 m-t-10">
      <b class="text-inverse ts-uppercase">{{ $t('homePage.myRequest') }}</b>
    </div>
    <div class="ts-h-40 overflow-auto">
      <div class="widget-list widget-list-rounded m-b-10">
        <a
          @click.prevent="requestStatus(0)"
          class="widget-list-item ts-whitespace-no-wrap"
        >
          <div class="widget-list-media icon">
            <i class="fas fa-user-edit bg-info text-white"></i>
          </div>
          <div class="widget-list-content">
            <h4 class="widget-list-title">
              {{ $t('homePage.requestEditProfilePending') }}
            </h4>
          </div>
          <div class="widget-list-action text-right">
            <span class="badge badge-info m-r-2">{{ pending }}</span>
            <i class="fa fa-angle-right fa-lg text-muted"></i>
          </div>
        </a>
        <a
          @click.prevent="requestStatus(1)"
          class="widget-list-item ts-whitespace-no-wrap"
        >
          <div class="widget-list-media icon">
            <i class="fas fa-user-cog bg-primary text-white"></i>
          </div>
          <div class="widget-list-content">
            <h4 class="widget-list-title">
              {{ $t('homePage.requestEditProfilePartiallyApproved') }}
            </h4>
          </div>
          <div class="widget-list-action text-right">
            <span class="badge badge-primary m-r-2">{{
              partiallyApproved
            }}</span>
            <i class="fa fa-angle-right fa-lg text-muted"></i>
          </div>
        </a>
        <a
          @click.prevent="requestStatus(2)"
          class="widget-list-item ts-whitespace-no-wrap"
        >
          <div class="widget-list-media icon">
            <i class="fas fa-user-check bg-success text-white"></i>
          </div>
          <div class="widget-list-content">
            <h4 class="widget-list-title">
              {{ $t('homePage.requestEditProfileApproved') }}
            </h4>
          </div>
          <div class="widget-list-action text-right">
            <span class="badge badge-success m-r-2">{{ approved }}</span>
            <i class="fa fa-angle-right fa-lg text-muted"></i>
          </div>
        </a>
        <a
          @click.prevent="requestStatus(3)"
          class="widget-list-item ts-whitespace-no-wrap"
        >
          <div class="widget-list-media icon">
            <i class="fas fa-user-times bg-danger text-white"></i>
          </div>
          <div class="widget-list-content">
            <h4 class="widget-list-title">
              {{ $t('homePage.requestEditProfileRejected') }}
            </h4>
          </div>
          <div class="widget-list-action text-right">
            <span class="badge badge-danger m-r-2">{{ rejected }}</span>
            <i class="fa fa-angle-right fa-lg text-muted"></i>
          </div>
        </a>
      </div>
    </div>
    <ts-card class="m-t-10">
      <ts-card-wrapper>
        <div class="ts-flex">
          <div class="ts-flex-grow"></div>
          <div class="ts-flex justify-content-end">
            <select class="form-control" v-model="approve_status">
              <option value>{{ $t('home.all') }}</option>
              <option :value="0">{{ $t('home.pending') }}</option>
              <option :value="1">{{ $t('home.partiallyApproved') }}</option>
              <option :value="2">{{ $t('home.approved') }}</option>
              <option :value="3">{{ $t('home.rejected') }}</option>
            </select>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.request_id }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.request_date }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.requester }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              <span
                class="badge badge-info"
                v-if="record.request_status == 'Pending'"
                >{{ $t('home.pending') }}</span
              >
              <span
                class="badge badge-primary"
                v-if="record.request_status == 'Partialy Approved'"
                >{{ $t('home.partiallyApproved') }}
              </span>
              <span
                class="badge badge-success"
                v-if="record.request_status == 'Approved'"
                >{{ $t('home.approved') }}</span
              >
              <span
                class="badge badge-danger"
                v-if="record.request_status == 'Rejected'"
                >{{ $t('home.rejected') }}</span
              >
            </td>
          </template>
        </ts-table>
      </div>
      <ts-card-wrapper class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'myRequest',
  data() {
    return {
      pending: 0,
      partiallyApproved: 0,
      approved: 0,
      rejected: 0,
      loading: false
    }
  },
  created() {
    this.fetchTotal()
    this.fetchResource()
  },
  computed: {
    ...mapState('home/studentMyRequest', [
      'resources',
      'pagination',
      'approveTypes'
    ]),
    search: {
      get() {
        return this.$store.state.home.studentMyRequest.search
      },
      set(newVal) {
        this.$store.commit('home/studentMyRequest/SET_SEARCH', newVal)
        this.$store.commit('home/studentMyRequest/RESET_CURRENT_PAGE')
      }
    },
    app_type_id: {
      get() {
        return this.$store.state.home.studentMyRequest.app_type_id
      },
      set(val) {
        this.$store.commit('home/studentMyRequest/SET_APP_TYPE_ID', val)
      }
    },
    approve_status: {
      get() {
        return this.$store.state.home.studentMyRequest.approve_status
      },
      set(newValue) {
        this.$store.commit('home/studentMyRequest/SET_APPROVE_STATUS', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('homePage.requestId') },
        { name: this.$t('homePage.requestDate'), style: 'text-align: center' },
        { name: this.$t('homePage.requester') },
        { name: this.$t('homePage.status'), style: 'text-align: center' }
      ]
    }
  },
  methods: {
    fetchResource() {
      this.$store
        .dispatch('home/studentMyRequest/fetchResource')
        .then(() => {
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchTotal() {
      this.$store
        .dispatch('home/studentMyRequest/fetchTotal')
        .then(response => {
          this.loading = false
          this.pending = response.pending
          this.partiallyApproved = response.partiallyApproved
          this.approved = response.approved
          this.rejected = response.rejected
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('home/studentMyRequest/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    requestStatus(status_id) {
      this.$store.commit(
        'home/studentRequestLinkFromHome/SET_APPROVE_STATUS',
        status_id
      )
      this.$router.push({
        name: 'my-request-list'
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    approve_status: debounce(function(approve_status) {
      this.fetchData({ approve_status })
    }, 500)
  }
}
</script>
